// resources/js/woocommerce/mini-cart/panel.js
import { els, qsa, css, xs } from './dom.js';

export function bindMiniXS(container = document) {
  qsa(xs.checkSel, container).forEach((chk) => {
    const li = chk.closest(xs.itemSel);
    if (!li) return;
    const sync = () => li.classList.toggle('is-checked', chk.checked);
    chk.addEventListener('change', sync);
    sync();
  });
}

export function openPanel() {
  const panel = els.panel();
  const overlay = els.overlay();
  if (!panel) return;
  panel.classList.add(css.active);
  panel.setAttribute('aria-hidden', 'false');
  overlay?.classList.add(css.active);
  els.toggles().forEach(t => t.setAttribute('aria-expanded', 'true'));
  bindMiniXS(panel);
}

export function closePanel() {
  const panel = els.panel();
  const overlay = els.overlay();
  if (panel) {
    panel.classList.remove(css.active);
    panel.setAttribute('aria-hidden', 'true');
  }
  overlay?.classList.remove(css.active);
  els.toggles().forEach(t => t.setAttribute('aria-expanded', 'false'));
}

export function bindInside() {
  const panel = els.panel();
  const close = els.close();
  close?.addEventListener('click', (e) => { e.preventDefault(); closePanel(); });
  panel?.addEventListener('transitionend', () => {
    if (!panel.classList.contains(css.active)) els.overlay()?.classList.remove(css.active);
  });
  if (panel) bindMiniXS(panel);
}

/** Bind alle toggles (ivm 3 breakpoints / meerdere knoppen) */
export function initPanel() {
  els.toggles().forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openPanel();
    }, { passive: false });
  });

  els.overlay()?.addEventListener('click', (e) => { e.preventDefault(); closePanel(); }, { passive: false });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });

  bindInside();
  bindMiniXS();
}
